import { connect } from 'react-redux';

import Sidebar from './';
import { getMessages, hideChat } from "../../actions/chatActions";

const mapStateToProps = state => ({
  chats: state.chats,
  users: state.users,
  identityId: state.identity.id,
  browserNotifications: state.browserNotifications
});

const mapDispatchToProps = dispatch => ({
  hideChat: chatIds => dispatch(hideChat(chatIds)),
  getMessages: chatId => dispatch(getMessages(chatId))
});

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
